import { render } from "./manage-products.vue?vue&type=template&id=aeea44a2"
import script from "./manage-products.vue?vue&type=script&lang=js"
export * from "./manage-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__